'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-combo-legend/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../sfdc-color-legend/index.js');

var _index4 = _interopRequireDefault(_index3);

var _index5 = require('../sfdc-gradient-legend/index.js');

var _index6 = _interopRequireDefault(_index5);

var _index7 = require('../sfdc-radial-legend/index.js');

var _index8 = _interopRequireDefault(_index7);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ref = _sdk2.default.utils;
var Padding = ref.Padding;
var dataUtils = ref.dataUtils;
var constants = ref.constants;
var configUtils = ref.configUtils;
var columnUtils = ref.columnUtils;
var valueFctUtils = ref.valueFctUtils;
var LOC = _sdk2.default.LOC;
var ref$1 = constants.CHART_LAYOUT;
var COLOR_TYPE = ref$1.COLOR_TYPE;
var colorUtils = _sdk2.default.color.colorUtils;

function shouldDisableLegendSelect(colorLayoutType, numDims, trellis, selectMode) {
  if (colorLayoutType === COLOR_TYPE.BINS && !numDims) {
    // disable legend selection when color type is bins and no (other) dimension is defined
    return true;
  } else if (dataUtils.includes([constants.SELECTMODE.SINGLE, constants.SELECTMODE.SINGLE_REQUIRED], selectMode)) {
    // when you can only select one shape disable selection:
    // - bin coloring(a bin could potentailly pick up multiple shapes)
    // - if in trellis mode (the selection would apply to *all* cells and would result in multiple selections)
    // - or if there are more dims to plot (the selection would select all the values for a given color...)
    return colorLayoutType === COLOR_TYPE.BINS || trellis || numDims > 1;
  } else {
    return false;
  }
}

exports.default = {
  santizeLegendChartConfig: function santizeLegendChartConfig(chartConfig, legendWidget) {
    var chartSize = chartConfig.size;
    var legendHorizontalSize = legendWidget.getHorizontalSize(chartSize);
    var legendVerticalSize = legendWidget.getVerticalSize(); // build legend config

    var legendConfig = chartConfig.legend;
    var vPad = Math.max(constants.LEGEND.MIN_PADDING, legendConfig.vPad);
    var hPad = Math.max(constants.LEGEND.MIN_PADDING, legendConfig.hPad);
    var inside = legendConfig.inside;
    var customSize = configUtils.getCustomCellSize(legendConfig);
    var chartPadding = chartConfig.padding;
    var chartW = chartSize[0] - chartPadding.left - chartPadding.right;
    var chartH = chartSize[1] - chartPadding.top - chartPadding.bottom;
    var sanitizedPos = this.sanitizeLegendPosition(legendConfig.position);
    var area = sanitizedPos.area;
    var alignment = sanitizedPos.alignment;
    var size;
    var fitWidth = true;
    var vertical = true; // layout orientation of legend tiles
    // allocate max legend size, infer layout orientation if not provided by config

    var isSideLegend = area === "left" || area === "right";
    var fullAlignment = alignment === 'full';

    if (isSideLegend || fullAlignment) {
      var initialSize = [legendVerticalSize[0], Math.min(legendVerticalSize[1], chartH)];
      var width = fullAlignment ? chartW : customSize ? chartW * customSize / 100 : Math.min(initialSize[0], chartW * 0.4);
      var height = fullAlignment ? customSize ? chartW * customSize / 100 : Math.min(initialSize[1], chartH * 0.4) : initialSize[1];
      size = [width, height]; // full alignment do not fit width so that legend takes max width

      fitWidth = !fullAlignment;
    } else {
      var initialSize$1 = [Math.min(legendHorizontalSize[0], chartW), legendHorizontalSize[1]];
      var height$1 = customSize ? chartH * customSize / 100 : Math.min(initialSize$1[1], chartH * 0.3);
      size = [initialSize$1[0], height$1];
      vertical = false;
    }

    var hasGradientLegend = legendWidget instanceof _index2.default ? legendWidget.getLegends().some(function (legend) {
      return legend instanceof _index6.default;
    }) : legendWidget instanceof _index6.default;
    this.defaultLegendSortingConfig(legendConfig, chartConfig.color, hasGradientLegend, vertical);

    if (size[0] <= 0 || size[1] <= 0) {
      return false;
    }

    size = [Math.ceil(size[0]), Math.ceil(size[1])];
    var legendInfo = this.computeLegendInfo(chartSize, chartPadding, size, area, alignment, inside, vPad, hPad);
    chartConfig.padding = legendInfo.chartPadding;
    chartConfig.legend = legendConfig;
    return {
      size: size,
      fitWidth: fitWidth,
      showBackground: inside,
      position: legendInfo.legendPosition,
      transforms: {
        rotate: !vertical,
        flipX: area === "right" // legend by default is vertical layout

      }
    };
  },

  /**
   * Default legend sorting config
   *  Sort Order:  "asc|desc"
   *     Gradient legend: vertical - descending, horizontal - ascending
   *     All other legends: default is ascending
   * Type:  "rows|values"
   *     "rows" - ordering by data rows or "mirroring" chart results
   *     "values" - ordering by legend values (like alphabetical)
   *     When there is no color config defined, type is "rows" so that the legend mirrors the chart results.
   *     For example, in multimetric, when color config is not specified, legend is measure.  Setting type to "rows" so that it follows the plots order.
   *     To match the existing behavior, when the "sortColor" is false, it means the color assignment is based on the unsorted domain.  Thus, setting type to "rows" to match the unsorted domain.
   *     "sortColor" is only used only in categorical layout and is default to true. Only a few charts (e.g. Funnel, Origami) default "sortColor" to false.
   *
  **/
  defaultLegendSortingConfig: function defaultLegendSortingConfig(legendConfig, colorConfig, hasGradientLegend, isVertical) {
    var defaultLegendSorting = {
      "order": hasGradientLegend && isVertical ? constants.SORT.ORDER.DESC : constants.SORT.ORDER.ASC
    }; // sortColor is only for categorical and default to true for most charts

    defaultLegendSorting.type = !colorConfig || colorConfig.sortColor === false ? constants.SORT.TYPE.ROWS : constants.SORT.TYPE.VALUES;
    legendConfig.sorting = _core2.default.defaults(legendConfig.sorting || {}, defaultLegendSorting);
  },
  getComboLegend: function getComboLegend(bottomLegend, topLegend) {
    // combine legends if have both
    if (bottomLegend && topLegend) {
      bottomLegend.extendConfig({
        headerAlign: "left",
        isCombo: true
      });
      topLegend.extendConfig({
        isCombo: true
      });
      return new _index2.default({
        selectMode: bottomLegend.getConfig().selectMode,
        selectionKeyFct: bottomLegend.getConfig().selectionKeyFct
      }, topLegend, bottomLegend);
    } else {
      return bottomLegend || topLegend;
    }
  },
  getRadialLegendFromLayout: function getRadialLegendFromLayout(radiusLayout, config) {
    if (!radiusLayout || radiusLayout.isConstant()) {
      return;
    }

    var commonLegendConfig = this.getCommonLegendConfig(config);
    var rField = radiusLayout.getField();
    return new _index8.default(_core2.default.extend(commonLegendConfig, {
      format: rField.getFormat(),
      maxRadius: radiusLayout.getMaxRadius(),
      maxValue: radiusLayout.getMaxValue(),
      headerText: columnUtils.defaultText(rField.getLabel(), rField.getName())
    }));
  },
  getColorLegendFromPlots: function getColorLegendFromPlots(plots, config) {
    if (_core2.default.find(plots, function (plot) {
      return !colorUtils.isColor(plot.color) || _core2.default.isEmpty(plot.column);
    })) {
      return;
    }

    var commonLegendConfig = this.getCommonLegendConfig(config);
    var unsortedDomain = plots.map(function (plot) {
      var column = plot.column[0];
      return columnUtils.defaultText(column.getLabel(), column.getName());
    }); // legend is going to show measure list
    // note: each measure already has its mark property set to "bar" in super.sanitizeConfig()
    // multi metrics color legend
    // For a combo, we want lines be last in plots so that the lines always on top.

    plots = _core2.default.sortBy(plots, function (plot) {
      return plot.mark === constants.MARK_TYPE.BAR ? 0 : 1;
    });
    var domain = plots.map(function (plot) {
      var column = plot.column[0];
      return columnUtils.defaultText(column.getLabel(), column.getName());
    });
    var colors = plots.map(function (plot) {
      return plot.color;
    });
    var marks = plots.map(function (plot) {
      return plot.mark;
    });
    return new _index4.default(_core2.default.extend(commonLegendConfig, {
      domain: domain,
      unsortedDomain: unsortedDomain,
      colors: colors,
      marks: marks,
      showPoints: config.showPoints,
      selectMode: constants.SELECTMODE.NONE,
      headerText: LOC.getLabel("wave-charts", "measure"),
      sorting: config.legend && config.legend.sorting
    }));
  },
  getGradientLegendFromLayout: function getGradientLegendFromLayout(colorLayout, config) {
    if (!colorLayout || colorLayout.isConstant()) {
      return;
    }

    var colorLayoutType = colorLayout.getType();

    if (colorLayoutType === constants.CHART_LAYOUT.COLOR_TYPE.GRADIENT) {
      var commonLegendConfig = this.getCommonLegendConfig(config);
      var column = colorLayout.getField();
      var colorScale = colorLayout.getScale();
      var domain = colorScale.domain();
      var headerText = columnUtils.defaultText(column.getLabel(), column.getName());
      var sorting = config.legend && config.legend.sorting;
      return new _index6.default(_core2.default.extend(commonLegendConfig, {
        domain: domain,
        range: colorLayout.getGradient(),
        format: column.getFormat(),
        headerText: headerText,
        sorting: sorting
      }));
    }
  },
  getCategoricalLegendFromLayout: function getCategoricalLegendFromLayout(colorLayout, config, keyColumns) {
    if (!colorLayout || colorLayout.isConstant()) {
      return;
    }

    var colorLayoutType = colorLayout.getType();

    if (colorLayoutType !== constants.CHART_LAYOUT.COLOR_TYPE.GRADIENT) {
      var commonLegendConfig = this.getCommonLegendConfig(config);
      var selectMode = config.selectMode;
      var trellis = config.trellis;
      var showPoints = config.showPoints;
      var legend = config.legend;
      var column = colorLayout.getField();
      var colorScale = colorLayout.getScale();
      var headerText = columnUtils.defaultText(column.getLabel(), column.getName());
      var domain = colorScale.domain();
      var unsortedDomain = colorLayout.getUnsortedDomain();
      var colors = colorScale.range();
      var labels = colorLayout.getLabels(); // assign selectMode for categorical/bin color legend

      var selectModeLegend = shouldDisableLegendSelect(colorLayoutType, columnUtils.uniqueColumns(keyColumns).length, trellis, selectMode) ? constants.SELECTMODE.NONE : selectMode;
      var isBinned = colorLayoutType === constants.CHART_LAYOUT.COLOR_TYPE.BINS;
      var commonSelectionKeyFct = valueFctUtils.getValueFct({
        field: column,
        defaultValue: ""
      }, isBinned);
      var selectionKeyFct;

      if (isBinned) {
        selectionKeyFct = function selectionKeyFct(row) {
          var bin = commonSelectionKeyFct(row);
          return bin.value;
        };
      } else {
        selectionKeyFct = commonSelectionKeyFct;
      }

      var sorting = legend && legend.sorting;
      return new _index4.default(_core2.default.extend(commonLegendConfig, {
        hotSpots: isBinned ? undefined : column.getHotSpots(),
        columnName: column.getName(),
        showPoints: showPoints,
        domain: domain,
        unsortedDomain: unsortedDomain,
        colors: colors,
        labels: labels,
        headerText: headerText,
        mark: colorLayout.getLegendSwatchType(),
        selectMode: selectModeLegend,
        selectionKeyFct: selectionKeyFct,
        sorting: sorting
      }));
    }
  },
  getColorLegendFromLayout: function getColorLegendFromLayout(colorLayout, config, keyColumns) {
    if (!colorLayout || colorLayout.isConstant()) {
      return;
    }

    switch (colorLayout.getType()) {
      case COLOR_TYPE.GRADIENT:
        return this.getGradientLegendFromLayout(colorLayout, config);

      default:
        return this.getCategoricalLegendFromLayout(colorLayout, config, keyColumns);
    }
  },
  getCommonLegendConfig: function getCommonLegendConfig(config) {
    var legendConfig = config.legend || {};
    return {
      dataCursor: config.dataCursor,
      swatchSize: legendConfig.swatchSize,
      swatchPadding: legendConfig.swatchPadding,
      showHeader: legendConfig.showHeader,
      fitHeight: legendConfig.fitHeight,
      theme: config.theme // consistent with the chart's theme

    };
  },
  //--------------------------------------------------------------------------------
  //
  // legend
  //
  //--------------------------------------------------------------------------------
  // sanitize legend position
  // - list of valid area and its corresponding valid alignment, first alignment
  // is returned if aligment is invalid. default area is 'right' if are is invalid.
  //
  // area - alignment
  // 'right' - 'top', 'middle', 'bottom'
  // 'left' - 'top', 'middle', 'bottom'
  // 'top' - 'center', 'left', 'right', 'full'
  // 'bottom' - 'center', 'left', 'right' 'full'
  //
  // @param position {String} legend position 'area-alignment', area of chart legend is
  // 							positioned, alignment of legend within the area
  sanitizeLegendPosition: function sanitizeLegendPosition(position) {
    var ref = position.split('-');
    var area = ref[0];
    var alignment = ref[1];

    if (!dataUtils.includes(['left', 'right', 'top', 'bottom'], area)) {
      area = "right";
    }

    if (dataUtils.includes(['left', 'right'], area)) {
      if (!dataUtils.includes(['top', 'middle', 'bottom'], alignment)) {
        alignment = 'top';
      }
    } else {
      if (!dataUtils.includes(['left', 'center', 'right', 'full'], alignment)) {
        alignment = 'center';
      }
    }

    return {
      area: area,
      alignment: alignment
    };
  },
  // returns legend and chart size and position considering legend config
  // - legendPosition: legend position relative to main chart
  // - chartPaddig: main chart padding considering space for legend
  //
  // @param chartSize {Array} [width, height] of chart
  // @param chartPadding {Object} chart padding
  // @param legendSize {Array} [width, height] of legend
  // @param area {String} area of chart legend is positioned
  // @param alignment {String} legend alignment
  // @param inside {Boolean} if legend is inside/outside chart
  // @param vPad {Number} vertical padding 1) outside: between legend and main chart 2) inside: around legend
  // @param hPad {Number} horizontal padding 1) outside: between legend and main chart 2) inside: around legend
  computeLegendInfo: function computeLegendInfo(chartSize, chartPadding, legendSize, area, alignment, inside, vPad, hPad) {
    var legendW = legendSize[0];
    var legendH = legendSize[1];
    chartPadding = new Padding(chartPadding);
    var chartW = chartSize[0] - chartPadding.left - chartPadding.right;
    var chartH = chartSize[1] - chartPadding.top - chartPadding.bottom;
    var vOffset = 0;
    var hOffset = 0;
    var hPos = area === 'right' || alignment === 'right' ? chartW - legendW - hOffset : area === 'left' || alignment === 'left' || alignment === 'full' ? hOffset : alignment === 'center' ? (chartW - legendW) / 2 : hOffset;
    var vPos = area === 'top' || alignment === 'top' ? vOffset : area === 'bottom' || alignment === 'bottom' ? chartH - legendH - vOffset : alignment === 'middle' ? (chartH - legendH) / 2 : vOffset;
    hPos += chartPadding.left;
    vPos += chartPadding.top; // increase chart padding to leave space for legend

    if (!inside) {
      switch (area) {
        case 'top':
          chartPadding.top += legendH + vPad;
          break;

        case 'bottom':
          chartPadding.bottom += legendH + vPad;
          break;

        case 'left':
          chartPadding.left += legendW + hPad;
          break;

        case 'right':
          chartPadding.right += legendW + hPad;
          break;
      }
    }

    return {
      legendPosition: [hPos, vPos],
      chartPadding: chartPadding.toJson()
    };
  }
};

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;